/**
 * 登录页面
 *
 * Author:   shann
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/3/16      1.0     First version
 *
 * Copyright  2021/3/16 , all rights reserved. Essa.cn
 * */
import React from "react";
import {
    Layout,
    Image,
    Row,
    Col,
    Card,
    Form,
    Input,
    Button,
    Checkbox,
    Select,
    message,
} from "antd";
import "./Login.less";
import logo from "../../assets/img/logo.png";
import Lang from "../../components/Lang/Lang";
import IconFont from "@components/IconFont";
import cover from "./cover.png";
import Auth from "../../utils/auth.js";
import { Redirect } from "react-router-dom";
import Cookie from "../../utils/cookie";
import Locale from "../../utils/locale";
import Helper from "../../utils/helper";

const { Header, Content, Footer } = Layout;
const { Option } = Select;

class LoginForm extends React.Component {
    state = {
        account: null,
        password: null,
        isLoggedIn: false,
        isRememberMe: false
    };

    /**
     * 账号密码
     * @param e
     */
    handleChange = e => {
        let state = {};
        let element = e.target;
        if (element.type === "text" || element.type === "password") {
            state[element.name] = element.value;
        } else if (element.type === "checkbox") {
            state[element.name] = element.checked;
        }
        this.setState(state);
    };

    /**
     * 立即登录
     * @param e
     */
    handleSubmit = e => {
        let { account, password } = this.state;
        // console.log(account);
        if (!account) {
            message.error(
                Lang({ id: "QingShuRuYongHuMing", default: "请输入用户名" })
            );
            return false;
        }
        if (!password) {
            message.error(Lang({ id: "QingShuRuMiMa", default: "请输入密码" }));
            return false;
        }
        Auth.login("/service/mg/public/user/login", {
            account,
            password: Helper.md5(account + password),
            lang: Locale.current()
        }).then(response => {
            let { data } = response;
            if (data.valid === true && data.success === true) {
                // 登录标识
                let options = this.state.isRememberMe ? { expires: 365 } : null;
                Cookie.set("fmg.extra", data.model, options);
                Cookie.set("fmg.sid", data.model.sid, options);
                // 跳转主页
                this.setState({
                    isLoggedIn: true
                });
            } else {
                message.error(data.message);
            }
        });
    };

    render() {
        let { account, password } = this.state;
        return (
            <div>
                <div>
                    <img src="https://oss.essaone.com/ESSAONE.svg" alt="essaone.com" style={{width:'224px'}} />
                </div>
                <h1 className="welcome"><Lang id="HuanYingDengLuGongZuoTai">欢迎登录工作台</Lang> </h1>
                <Form layout="vertical">
                    <Form.Item
                        label={Lang({ id: "YongHuMing", children: "用户名" })}
                    >
                        <Input
                            placeholder={Lang({
                                id: "YongHuMing",
                                children: "用户名"
                            })}
                            value={account}
                            size={'large'}
                            onChange={this.handleChange}
                            name="account"
                            className="logo-input"
                        />
                    </Form.Item>
                    <Form.Item label={Lang({ id: "MiMa", children: "密码" })}>
                        <Input
                            placeholder={Lang({ id: "MiMa", children: "密码" })}
                            value={password}
                            size={'large'}
                            onChange={this.handleChange}
                            name="password"
                            type="password"
                            className="logo-input"
                        />
                    </Form.Item>
                    <Form.Item valuePropName="checked">
                        <Checkbox
                            onChange={this.handleChange}
                            name="isRememberMe"
                        >
                            <Lang id="JiZhuMiMa">记住密码</Lang>
                        </Checkbox>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            block
                            size={'large'}
                            className="logo-btn"
                            onClick={this.handleSubmit}
                        >
                            <Lang id="LiJiDengLu">立即登录</Lang>
                        </Button>
                    </Form.Item>
                </Form>
                {this.state.isLoggedIn && <Redirect to="/" />}
            </div>
        );
    }
}

class Login extends React.Component {
    state = {
        lang: Locale.current()
    };

    handleChange = value => {
        Locale.set("fmg.lang", value, { expires: 7 });
        window.location.reload();
    };

    render() {
        let { lang } = this.state;
        return (
            <Layout className="Login">
                <Header className="Login-header"  style={{ position: 'fixed', top:'15px' ,zIndex: 1, width: '100%' }}>
                    <div className="container">
                        {/* <Image width="220" height="32" src={logo} /> */}
                        <Select
                            defaultValue={lang}
                            className="select-style"
                            style={{ width: 120, float:'right'}}
                            bordered={false}
                            onChange={this.handleChange}>
                            <Option value="zh">中文</Option>
                            <Option value="en">English</Option>
                            <Option value="ru">Русский</Option>
                        </Select>
                    </div>
                </Header>
                <Content className="Login-content">
                    <div className="container">
                        <Row>
                            <Col span={8}>
                                <div className="left-img">
                                    <Image
                                        src={'https://oss.essaone.com/d2029a50-1df4-4015-87c6-7079573ee024.png'}
                                        preview={false}
                                        className="img-txt"
                                    />
                                    <Image
                                        src={'https://oss.essaone.com/81884f03-da57-4259-abcf-99f67fa6d3a6.png'}
                                        preview={false}
                                    />
                                </div>

                            </Col>
                            <Col span={16} className="login-box">
                                <Card
                                    // title={Lang({
                                    //     id: "EGuoYunYingPingTai",
                                    //     default: "ЭЛИТИМ运营平台"
                                    // })}
                                    className="Login-form"
                                >
                                   
                                    <LoginForm />






                                </Card>
                                <div className="foot-info">
                                        Copyright © 2013-2021 广东宜采科技有限公司 All rights
                                            reserved.
                                            {/* <a
                                                href="http://beian.miit.gov.cn"
                                                target="_blank"
                                                rel="noreferrer"
                                            > */}
                                                粤ICP备16027472号
                                            {/* </a> */}
                                    </div>
                            </Col>
                        </Row>
                    </div>
                </Content>

            </Layout>
        );
    }
}

export default Login;
